import { Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import { PATH_MANAGEMENT } from 'src/routes/paths';
import ReportManagement from 'src/sections/@dashboard/managements/report/ReportManagement';

const Reports = () => {
    const { themeStretch } = useSettings();

  return (
    <>
      <Page title="گزارشات">
              <Container maxWidth={themeStretch ? false : "lg"}>

          <HeaderBreadcrumbs
            heading={'گزارشات'}
            links={[
              {
                name: 'مدیریت',
                href: PATH_MANAGEMENT.management.root,
              },

              { name: 'گزارشات'},
            ]}
          />
          <ReportManagement/>
    </Container>
      </Page>
    </>
  );
};

export default Reports;
